import { WebSearchSettings, AgentLink } from "../types/webSearchSettings";

/**
 * Generate instruction text based on web search settings
 */
export function generateWebSearchInstructions(
  settings: WebSearchSettings, 
  organizationWebsite?: string | null
): string {
  const instructions: string[] = [];
  
  // Check if any search is enabled
  if (!settings.google_search && !settings.company_website && 
      (!settings.links || settings.links.length === 0) && 
      (!settings.selected_links || settings.selected_links.length === 0)) {
    return ""; // No web search capabilities enabled
  }
  
  instructions.push("Web Search Instructions:");
  
  // Google search logic
  if (settings.google_search) {
    instructions.push("you can browse the internet to answer the user's query if necessary");
  } else {
    instructions.push("You should never browse the entire internet, only browse the websites provided if provided and if necessary.");
  }
  
  // Company website
  if (settings.company_website) {
    if (organizationWebsite) {
      instructions.push(`You can browse our company website to answer the user's query: ${organizationWebsite}`);
    } else {
      instructions.push("The company website URL is not configured, so skip company-site browsing.");
    }
  }
  
  // Links in new format
  if (settings.links && settings.links.length > 0) {
    const linksList = settings.links.map((link: AgentLink) => link.url).join(", ");
    instructions.push(`You can browse these websites to answer the user's query: ${linksList}`);
    
    // Add detailed link information
    instructions.push("\nDetailed website information:");
    settings.links.forEach((link: AgentLink, index: number) => {
      let linkInfo = `${index + 1}. ${link.title} (${link.url})`;
      
      if (link.description) {
        linkInfo += `\n   Description: ${link.description}`;
      }
      
      if (link.ai_instructions) {
        linkInfo += `\n   INSTRUCTIONS: ${link.ai_instructions}`;
      }
      
      instructions.push(linkInfo);
    });
  }
  // Legacy selected_links
  else if (settings.selected_links && settings.selected_links.length > 0) {
    const linksList = settings.selected_links.join(", ");
    instructions.push(`You can browse these websites to answer the user's query: ${linksList}`);
    
    instructions.push("\nAdditional websites you can access:");
    settings.selected_links.forEach((url: string, index: number) => {
      instructions.push(`${index + 1}. ${url}`);
    });
  }
  
  // Custom web search instructions
  if (settings.web_search_instructions) {
    instructions.push(`Important instructions on how to use web search tool: ${settings.web_search_instructions}`);
  }
  
  return instructions.join("\n\n");
} 